import { useState } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Settings2 } from "lucide-react";
import { STATUS_CLS, LANGS } from "./api";
import { ConfigDialog } from "./ConfigDialog";

export function CentresPanel({ token, meta, reload }) {
  const [edit, setEdit] = useState(null);
  return (
    <div className="overflow-x-auto rounded border" data-testid="air-centres">
      <table className="w-full text-xs">
        <thead className="bg-muted/50 text-left"><tr>
          {["Centre", "Official phone", "WhatsApp", "AI status", "Language", "Voice provider", "Total calls", "Missed", "Enquiries", "Bookings", ""].map((h) => <th key={h} className="p-2">{h}</th>)}
        </tr></thead>
        <tbody>{meta.centres.map((c) => (
          <tr key={c.code} className="border-t" data-testid={`air-centre-${c.code}`}>
            <td className="p-2"><p className="font-medium">{c.name}</p><p className="text-muted-foreground">{c.code} · {c.country}</p></td>
            <td className="p-2">{c.phone || "—"}</td><td className="p-2">{c.whatsapp_number || "—"}</td>
            <td className="p-2"><Badge className={STATUS_CLS[c.status]} data-testid={`air-status-${c.code}`}>{c.status.replace(/_/g, " ")}</Badge>{c.enabled && <span className="ml-1 text-emerald-700">ON</span>}</td>
            <td className="p-2">{LANGS[c.language]}</td>
            <td className="p-2">{c.provider}{c.provider_number ? ` · ${c.provider_number}` : " · not connected"}</td>
            <td className="p-2">{c.total_calls}</td><td className="p-2">{c.missed_calls}</td><td className="p-2">{c.enquiries}</td><td className="p-2">{c.bookings}</td>
            <td className="p-2">{meta.is_super_admin && <Button size="sm" variant="outline" className="h-7" onClick={() => setEdit(c.code)} data-testid={`air-config-${c.code}`}><Settings2 className="mr-1 h-3 w-3" />Configure</Button>}</td>
          </tr>))}</tbody>
      </table>
      {edit && <ConfigDialog token={token} code={edit} onClose={() => setEdit(null)} onSaved={reload} />}
    </div>
  );
}
